import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import app from "./modules/app";
import session from "./modules/session";
import account from "./modules/account";
import user from "./modules/user";
import role from "./modules/role";
import tenant from "./modules/tenant";
import topic from "./modules/articles/topic";
import articleCategory from "./modules/articles/article-category";
import article from "./modules/articles/article";
import court from "./modules/booking/court";
import constitute from "./modules/booking/constitute";
import offerDateType from "./modules/booking/offerDateType";
import courtReview from "./modules/booking/courtReview";
import courtService from "./modules/booking/courtService";
import offer from "./modules/booking/offer";
import order from "./modules/booking/order";
import homeSlider from "./modules/booking/homeSlider";
import common from "./modules/common";
import verifyOffer from "./modules/booking/verifyOffer";
import recruit from "./modules/booking/recruit";
import notice from "./modules/notice";
import holiday from "./modules/booking/holiday";
import closure from "./modules/booking/closure";
import secondHand from "./modules/booking/secondHand";
import preferential from "./modules/booking/preferential";
import ticket from "./modules/ticket";
import groupBuy from "./modules/booking/groupBuy";
import membership from "./modules/membership";
import membershipTrade from "./modules/membershipTrade";
import coupon from "./modules/booking/coupon";
import couponTransfer from "./modules/booking/couponTransfer";
import couponCourt from './modules/booking/couponCourt'
import joinGroupBuyRecord from "./modules/booking/joinGroupBuyRecord";
import buyCardRecord from './modules/booking/buyCardRecord'
import supplier  from "./modules/booking/supplier";
import supplierOffer from "./modules/booking/supplierOffer";
import offerDateSlot from "./modules/booking/offerDateSlot";
import offerTimeSlot from "./modules/booking/offerTimeSlot";
import supplierOfferItem from "./modules/booking/supplierOfferItem";
import courtInstallation from "./modules/booking/courtInstallation";
import secondHandOrder from "./modules/booking/secondHandOrder";
import membershipDemand from "./modules/membershipDemand";
import merchant from "./modules/merchant";
const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {},
  modules: {
    app,
    session,
    account,
    user,
    role,
    tenant,
    topic,
    articleCategory,
    article,
    court,
    constitute,
    offerDateType,
    courtReview,
    courtService,
    offer,
    order,
    homeSlider,
    common,
    verifyOffer,
    recruit,
    notice,
    holiday,
    closure,
    secondHand,
    preferential,
    ticket,
    membership,
    membershipTrade,
    groupBuy,
    coupon,
    couponTransfer,
    couponCourt,
    joinGroupBuyRecord,
    buyCardRecord,
    supplier,
    supplierOffer,
    offerDateSlot,
    offerTimeSlot,
    supplierOfferItem,
    courtInstallation,
    secondHandOrder,
    membershipDemand,
    merchant
  },
});

export default store;
